import { render } from "./MemberService.vue?vue&type=template&id=334ff8f0"
import script from "./MemberService.vue?vue&type=script&lang=js"
export * from "./MemberService.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__